import { Dispatch, iRootState } from '..'

import { getUser } from 'src/api/user/user'

export interface City {
  name: string
  country: string
  state?: string
  lat?: number
  lng?: number
}

export interface Gender {
  id: number
  name: string
}

export interface Connections {
  id: null
  userId: null
  otherUserId: null
  status: null
  conversationId: null
  connectInitiatorUserId: null
  disconnectInitiatorUserId: null
  updatedAt: null
  deletedAt: null
  createdAt: null
}

export interface IUser {
  id: string
  email: string
  gender: Gender
  birthday: string
  username: string
  firstName: string
  city: City
  instagram: string
  twitter: string
  profilePicture: string
  profileComplete: boolean
  connections: Connections
  updatedAt: string
  deletedAt: null | string
  createdAt: string
  interestedIn: null
  friendshipPreferenceInterest: null
  friendshipPreferenceAgeMin: null
  friendshipPreferenceAgeMax: null
  datingPreferenceInterest: null
  datingPreferenceAgeMin: null
  datingPreferenceAgeMax: null
  countryCode: null
  phoneNumber: null
}

interface IUserModelState {
  data: IUser | null
  error: string | null
  isAuthResolved: boolean
}

interface IUserModel<T = IUserModelState> {
  state: T
  reducers: {
    setUser: (state: T, newState: IUser) => T
    updateUser: (state: T, newUserProp: Partial<IUser>) => T
    removeUser: (state: T) => T
    setError: (state: T, error: string) => T
    setAuthResolved: (state: T, isAuthResolved: boolean) => T
  }
  effects: (
    dispatch: Dispatch
  ) => {
    fetchLoggedInUser: (_: undefined, state: iRootState) => Promise<void>
  }
}

export const user: IUserModel = {
  state: {
    data: null,
    error: null,
    isAuthResolved: false,
  },
  reducers: {
    setUser: (state, data) => {
      return {
        ...state,
        data: {
          ...state.data,
          ...data,
        },
      }
    },
    updateUser: (state, payload) => ({
      ...state,
      data: {
        ...state.data!,
        ...payload,
      },
    }),
    removeUser: (state) => ({ ...state, data: null }),
    setError: (state, error) => ({ ...state, error }),
    setAuthResolved: (state, isAuthResolved) => ({ ...state, isAuthResolved }),
  },
  effects: (dispatch: Dispatch) => ({
    async fetchLoggedInUser() {
      try {
        const userResp = await getUser()
        dispatch.user.setUser(userResp)
        dispatch.user.setAuthResolved(true)
      } catch (e) {
        dispatch.user.setError('fetching logged in user failed')
        dispatch.user.setAuthResolved(true)
        console.error(e)
      }
    },
  }),
}
